import styled from 'styled-components';

export const DoughnutWrapper = styled.div`
  width: 146px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: none;
  position: relative;
`;

export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
